export const priceSet = (value, postfix = '') => {
  const new_value = String(value).replace(/,/g, '.');
  return (
    String(
      Number.prototype.toFixed.call(parseFloat(new_value) || 0, 2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '),
    ).replace(/\./g, ',') + postfix
  );
};
